import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";
import { jwtDecode } from "jwt-decode";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class CustomerAPI {

    URI_V1 = "/v1/customers"

    getCustomers = async () => {
        return await apiService.get(`${this.URI_V1}/company/${companyAPI.getCompanyManagment().id}`);
    };

    getCustomersPaginated = async ({ page = 0, limit = 20, q = "", requestLastVisit = false, birthdayMonth = false, } = {}) => {
        const companyId = companyAPI.getCompanyManagment().id;

        return await apiService.get(`${this.URI_V1}`, {
            params: {
                companyId,
                page,
                limit,
                requestLastVisit: requestLastVisit,
                birthdayMonth,
                q: q?.trim() ? q.trim() : undefined,
            },
        });
    };

    update = async (id: any, data: any) => {
        return await apiService.put(`${this.URI_V1}/${id}`, data);
    };

    getHistory = async (customerId: any) => {
        return await apiService.get(`${this.URI_V1}/${customerId}/history?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    create = async (data: any) => {
        return await apiService.post(`${this.URI_V1}?companyId=${companyAPI.getCompanyManagment().id}`, data);
    };

    deleteCustomer = async (customerId: any) => {
        return await apiService.delete(`${this.URI_V1}/${customerId}?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    importCustomers = async (formData: any) => {
        return await apiService.postFormData(`${this.URI_V1}/import-customer?companyId=${companyAPI.getCompanyManagment().id}`, formData);
    };
}
